import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
  sendPasswordResetEmail,
  sendEmailVerification,
  updateProfile,
  updatePassword,
} from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../config/firebase";

const login = async (email, password) => {
  try {
    const userCredentials = await signInWithEmailAndPassword(
      auth,
      email,
      password,
    );
    const user = userCredentials.user;
    return user;
  } catch {
    return false;
  }
};

const logout = async () => {
  try {
    await signOut(auth);
  } catch {
    return false;
  }
};

const registerUser = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password,
    );
    const user = userCredential.user;
    return user;
  } catch {
    return false;
  }
};

const registerUserWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  await signInWithPopup(auth, provider)
    .then((result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      GoogleAuthProvider.credentialFromResult(result);
    })
    .catch((error) => {
      // Handle Errors here.
      console.error(error);
    });
};

const registerUserWithFacebook = async () => {
  const provider = new FacebookAuthProvider();
  await signInWithPopup(auth, provider)
    .then((result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      FacebookAuthProvider.credentialFromResult(result);
    })
    .catch((error) => {
      // Handle Errors here.
      console.error(error);
    });
};

const sendResetPasswordEmail = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
  } catch (error) {
    console.error(`Error while sending reset password link ${error}`);
    return error;
  }
};

const sendVerificationEmail = async () => {
  const user = auth.currentUser;
  try {
    await sendEmailVerification(user);
  } catch (error) {
    console.error(`Error while sending email verification email ${error}`);
    return error;
  }
};

const getDocument = (id) => {
  return doc(db, "users", id);
};

const getCurrentUserData = async (id) => {
  const docRef = getDocument(id);
  const docSnap = await getDoc(docRef);
  const currentUserData = docSnap.data();
  return docSnap.exists() ? { ...currentUserData, id: docSnap.id } : null;
};

const updateUser = async (data) => {
  if (!data) return;
  try {
    const user = auth.currentUser;
    await updateProfile(user, data);
  } catch (error) {
    console.error(`Error while updating user data ${error}`);
    return error;
  }
};

const checkOldPassword = async (email, oldPassword, newPassword) => {
  if (!oldPassword || !newPassword) return;
  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      oldPassword,
    );
    if (userCredential) {
      await updatePassword(userCredential.user, newPassword);
      return true;
    }
  } catch (err) {
    return false;
  }
};

const observer = (callback) => onAuthStateChanged(auth, callback);

export {
  registerUser,
  login,
  logout,
  observer,
  registerUserWithGoogle,
  registerUserWithFacebook,
  sendResetPasswordEmail,
  sendVerificationEmail,
  getCurrentUserData,
  updateUser,
  checkOldPassword,
};
